export const regExpTime: RegExp = /(?<=\s|^)(((в )?([0-1][0-9]|2[0-3])(:[0-5][0-9]))|(в )([0-1][0-9]|2[0-3]))(?=\s|$)/gi;
export const regExpToday: RegExp = /(?<=\s|^)сегодня(?=\s|$)/gi;
export const regExpNoDate: RegExp = /(?<=\s|^)без\sсрока(?=\s|$)/gi;
export const regExpAfterTomorrow: RegExp = /(?<=\s|^)(?<!завтра)послезавтра(?=\s|$)/gi;
export const regExpTomorrow: RegExp = /(?<=\s|^)(?<!после)завтра(?=\s|$)/gi;
export const regExpDifferentDay: RegExp = /(?<=\s|^)(1?[0-9]|2[0-9]|3[01])\s(янв(аря)?|фев(раля)?|мар(та)?|апр(еля)?|мая|июн(я)?|июл(я)?|авг(уста)?|сен(тября)?|окт(ября)?|ноя(бря)?|дек(абря)?)(?=\s|$)/gi;
export const regExpPriority: RegExp = /(?<=\s|^)(?<!\w)!![0-3](?!\w)(?=\s|$)/g;
export const regExpTag: RegExp = /(?<=\s|^)(@|")(?=\s|$)/g;
export const regExpTagCoincidences: RegExp = /(?<=\s|^)(@|")[\p{L}\d_]+(?=\s|$)/gu;
export const regExpHoursTask: RegExp = /(?<=\s|^)(на )?([0-1]?[0-9]|2[0-3])(\s)?час(а|ов)?(?=\s|$)/gi;
export const regExpMinutesTask: RegExp = /(?<=\s|^)(на )?([0-5]?[0-9])(\s)?минут(а|у|ы)?(?=\s|$)/gi;
export const regExpHoursTaskShort: RegExp = /(?<=\s|^)(на )?([0-1]?[0-9]|2[0-3])(\s)?ч(?=\s|$)/gi;
export const regExpMinutesTaskShort: RegExp = /(?<=\s|^)(на )?([0-5]?[0-9])(\s)?(мин)(?=\s|$)/gi;
// export const regExpFullTimeTask: RegExp = /(?<=\s|^)(на )?([0-1]?[0-9]|2[0-3])\sчас(а|ов) ([0-5]?[0-9])(\s?)минут(а|у|ы)?(?=\s|$)/gi
export const regExpDaysOfWeek: RegExp = /(?<=\s|^)(((в )((понедельник|пн)|(среду|ср)|(четверг|чт)|(пятницу|пт)|(субботу|сб)|(воскресенье|вс)))|((во )((вторник|вт)))|((?<!каждый )(понедельник|пн)|(?<!каждый )(вторник|вт)|(?<!каждую )(среду|ср)|(?<!каждый )(четверг|чт)|(пятница|(?<!каждую )пт)|(суббота|(?<!каждую )сб)|(?<!каждое )(воскресенье|вс)))(?=\s|$)/gi;
export const regExpNextWeek: RegExp = /(?<=\s|^)через неделю(?=\s|$)/gi;
export const regExpNextMonth: RegExp = /(?<=\s|^)через месяц(?=\s|$)/gi;
export const regExpNextYear: RegExp = /(?<=\s|^)через год(?=\s|$)/gi;
export const regExpRepeat_NoRepeat: RegExp = /(?<=\s|^)не повторять(?=\s|$)/gi;
export const regExpRepeat_EveryDay: RegExp = /(?<=\s|^)каждый день(?=\s|$)/gi;
export const regExpRepeat_EveryMonth: RegExp = /(?<=\s|^)каждый месяц|ежемесячно(?=\s|$)/gi;
export const regExpRepeat_onWeekDays: RegExp = /(?<=\s|^)по будням(?=\s|$)/gi;
export const regExpRepeat_LastDayOfMonth: RegExp = /(?<=\s|^)последний день месяца|конец месяца(?=\s|$)/gi;
export const regExpRepeat_Mon: RegExp = /(?<=\s|^)каждый (понедельник|пн)(?=\s|$)/gi;
export const regExpRepeat_Tue: RegExp = /(?<=\s|^)каждый (вторник|вт)(?=\s|$)/gi;
export const regExpRepeat_Wen: RegExp = /(?<=\s|^)каждую (среду|ср)(?=\s|$)/gi;
export const regExpRepeat_Thu: RegExp = /(?<=\s|^)каждый (четверг|чт)(?=\s|$)/gi;
export const regExpRepeat_Fri: RegExp = /(?<=\s|^)каждую (пятницу|пт)(?=\s|$)/gi;
export const regExpRepeat_Sat: RegExp = /(?<=\s|^)каждую (субботу|сб)(?=\s|$)/gi;
export const regExpRepeat_Sun: RegExp = /(?<=\s|^)каждое (воскресенье|вс)(?=\s|$)/gi;

export const regExpArray: RegExp [] = [
    regExpTime,
    regExpToday,
    regExpNoDate,
    regExpTomorrow,
    regExpAfterTomorrow,
    regExpDifferentDay,
    regExpPriority,
    // regExpTag,
    regExpHoursTask,
    regExpMinutesTask,
    regExpNextWeek,
    regExpNextMonth,
    regExpNextYear
]

export const regExpGroups = {
    FullTime: [],
    FullDate: [],
    Date: [
        regExpToday,
        regExpTomorrow,
        regExpAfterTomorrow,
        regExpNoDate,
        regExpDaysOfWeek,
        regExpDifferentDay,
        regExpNextWeek,
        regExpNextMonth,
        regExpNextYear
    ],
    TimeHours: [
        regExpHoursTask,
        regExpHoursTaskShort
    ],
    TimeMinutes: [
        regExpMinutesTask,
        regExpMinutesTaskShort
    ],
    TaskTime: [
        regExpTime
    ],
    TaskPriority: [
        regExpPriority
    ],
    TaskRepeat: [
        regExpRepeat_NoRepeat,
        regExpRepeat_EveryDay,
        regExpRepeat_EveryMonth,
        regExpRepeat_LastDayOfMonth,
        regExpRepeat_onWeekDays,
        regExpRepeat_Mon,
        regExpRepeat_Tue,
        regExpRepeat_Wen,   
        regExpRepeat_Thu,
        regExpRepeat_Fri,
        regExpRepeat_Sat,
        regExpRepeat_Sun
    ],
    TaskTags: [
        regExpTag,
        regExpTagCoincidences
    ] 
}
// old format
// export const regExpHoursTask: RegExp = /(?<=\s|^)(на )?([0-1]?[0-9]|2[0-3])(\s?)час(а?|ов)?(?=\s|$)/gi;
// export const regExpMinutesTask: RegExp = /(?<=\s|^)(на )?([0-5]?[0-9])(\s?)минут(а|у|ы)?(?=\s|$)/gi;


// (?:каждую|каждый)\s+(пн|вт|ср|чт|пт|сб|вс|понедельник|вторник|среда|четверг|пятница|суббота|воскресенье)(?:\s+(пн|вт|ср|чт|пт|сб|вс|понедельник|вторник|среда|четверг|пятница|суббота|воскресенье))*